import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {combineLatest, Subscription} from 'rxjs';
import {ThemeService} from '@app/core/service/theme.service';

@Component({
    selector: 'ngc-auth-error',
    templateUrl: './auth-error.component.html',
    styleUrls: ['./auth-error.component.scss']
})
export class AuthErrorComponent implements OnInit, OnDestroy {

    public errorCode: number;
    public title: string;
    public message1: string;
    public message21: string;
    public message22: string;
    public message31: string;
    public supportTitle: string;
    public supportTitle2: string;
    public supportUrl: string;
    public supportUrl2: string;
    public showLoginLink = true;

    private readonly ErrorTitleMap = new Map<number, string>([
        [401, 'Access denied'],
        [500, 'Server error occurred'],
    ]);

    private subscriptions: Subscription[] = [];

    constructor(private activatedRoute: ActivatedRoute,
                private themeService: ThemeService) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            combineLatest(
                this.activatedRoute.queryParams,
                this.themeService.getBundle()
            ).subscribe(([params, bundle]: [Params, any]) => {
                this.errorCode = +params['errorCode'];
                this.title = this.ErrorTitleMap.has(this.errorCode) ? this.ErrorTitleMap.get(this.errorCode) : params['message'];

                if (bundle) {
                    this.supportTitle = 'Support';
                    this.message1 = 'You do not have access to this service.';
                    this.message21 = 'Please contact';
                    this.message22 = 'to gain access.';
                    this.supportUrl = (bundle['footer'] && bundle['footer']['supportLink'] && bundle['footer']['supportLink']['url']
                        ? bundle['footer']['supportLink']['url'] : null);

                    if (bundle['authError']) {
                        this.supportTitle = (bundle['authError']['supportTitle'] ? bundle['authError']['supportTitle'] : this.supportTitle);
                        this.supportTitle2 = (bundle['authError']['supportTitle2'] ? bundle['authError']['supportTitle2'] : '');
                        this.supportUrl = (bundle['authError']['supportUrl'] ? bundle['authError']['supportUrl'] : this.supportUrl);
                        this.supportUrl2 = (bundle['authError']['supportUrl2'] ? bundle['authError']['supportUrl2'] : '');

                        if (this.errorCode === 401) {
                            this.title = (bundle['authError'].hasOwnProperty('authError401Title') ? bundle['authError']['authError401Title'] : this.title);
                            this.message1 = (bundle['authError']['authError401Msg1'] ? bundle['authError']['authError401Msg1'] : this.message1);
                            this.message21 = (bundle['authError']['authError401Msg21'] ? bundle['authError']['authError401Msg21'] : this.message21);
                            this.message22 = (bundle['authError']['authError401Msg22'] ? bundle['authError']['authError401Msg22'] : this.message22);
                            this.message31 = (bundle['authError']['authError401Msg31'] ? bundle['authError']['authError401Msg31'] : '');
                        }
                        this.showLoginLink = (bundle['authError'].hasOwnProperty('showLoginLink') ? bundle['authError']['showLoginLink'] : this.showLoginLink);
                    }
                }

            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
